import axios from 'axios';

let Api_Url="";

const setApiUrl = (url) => {
  Api_Url = url;
};

const Registration_Service = {  
  setApiUrl,
  getAll: () => axios.get(Api_Url),
  getById: (id) => axios.get(`${Api_Url}/${id}`),
  //getVendorList: (Uname) => axios.get(`${Api_Url}/${Uname}`),
  create: (data) => axios.post(Api_Url, data),


  uploadVendorDocuments: (formData) =>
  axios.post(
    `${sessionStorage.getItem("APIUrl")}/api/Registration/UploadVendorDocuments`,
    formData
  ),


    // Open an existing uploaded document
  getDocumentUrl: (filePath) => {
    if (!filePath) return "";

    const apiUrl = sessionStorage.getItem("APIUrl");

    return `${apiUrl}/api/Registration/OpenDocument?path=${encodeURIComponent(filePath)}`;
  },

  //update: (id, data) => axios.put(`${Api_Url}/${id}`, data),
  remove: (catId,catName,opFlag) => axios.delete(`${Api_Url}/${catId}/${catName}/${opFlag}`),


  // Vendor approval status
  getVendorApprovalStatus: () =>
  axios.get(
    `${sessionStorage.getItem("APIUrl")}/api/VndrAprvl/Status`
  ),
};

export default Registration_Service;
